import * as React from 'react';

import { BuilderLinkBlock } from '../../components/Builder/component/BuilderLinkBlock';
import { IStatsView } from '../../types/newbuilding/builder';

interface IBuilderHousesLinkProps {
  stats: IStatsView | null;
  type: 'done' | 'inProgress';
}

export function BuilderHousesLink({ stats, type }: IBuilderHousesLinkProps) {
  const { housesCount, housesText, newbuildingText, qs } = stats || {};

  if (!housesCount || !housesText || !newbuildingText || !qs) {
    return null;
  }

  return <BuilderLinkBlock count={housesCount} url={qs} newbuildingText={newbuildingText} type={type} />;
}
